module.exports = __webpack_public_path__ + "8a97e513dc15635e7f11f1021a3f59a8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/hootagotchi.png
// module id = 3014
// module chunks = 0